import {
  Button,
  ButtonDropdown,
  Container,
  Grid,
  Header,
  Popover,
  SpaceBetween,
  StatusIndicator,
} from '@cloudscape-design/components';
import { ProcessNames } from '@parallel-fluidics/shared/constants';
import PLCNumberEditor from 'features/plc/components/PLCNumberEditor';
import PLCToggleButton from 'features/plc/components/PLCToggleButton';
import { FORMING_SOAK_TIME_FIELDS, FORMING_TEMP_FIELDS_BY_SIDE } from 'features/plc/contracts/pressHMI.fields';
import {
  PLC_PATHS,
} from 'features/plc/contracts/pressHMI.schema';
import { usePLCValue, usePLCWriteState } from 'features/plc/providers/PLCProvider';
import ProcessLogPanel from 'features/processLog/components/ProcessLogPanel';
import React, { useState } from 'react';

import LoadConfigModal from '../components/loadConfigModal';
import ProcessStatus from '../components/processStatus';
import StartRunModal from '../components/startRunModal';
import TemperaturePanel from '../components/temperaturePanel';

export default function AutomationControls() {
  const { runWrite } = usePLCWriteState();
  const safetyOk = usePLCValue(PLC_PATHS.status.safetyOk);
  const automationEnabled = usePLCValue(PLC_PATHS.cmd.automationEnable);
  const processLogId = usePLCValue(PLC_PATHS.meta.processLogId);
  const [isStartModalOpen, setIsStartModalOpen] = useState(false);
  const [isLoadModalOpen, setIsLoadModalOpen] = useState(false);

  let automationAction = (
    <Button onClick={() => { setIsStartModalOpen(true); }}>Enable automation</Button>
  );

  if (automationEnabled) {
    automationAction = (
      <Button
        variant="primary"
        onClick={() => {
          runWrite({ path: PLC_PATHS.cmd.automationEnable, value: false });
        }}
      >
        Disable automation
      </Button>
    );
  } else if (!safetyOk) {
    automationAction = (
      <Popover
        dismissButton={false}
        size="small"
        triggerType="custom"
        content={<StatusIndicator type="error">Safety is not OK</StatusIndicator>}
      >
        <Button>Enable automation</Button>
      </Popover>
    );
  }

  return (
    <Container
      header={(
        <Header
          variant="h2"
          actions={(
            <SpaceBetween direction="horizontal" size="xs">
              <ButtonDropdown
                items={[
                  {
                    text: 'Load previous configuration',
                    id: 'load',
                  },
                ]}
                onItemClick={({ detail }) => {
                  if (detail.id === 'load') {
                    setIsLoadModalOpen(true);
                  }
                }}
              >
                Configuration
              </ButtonDropdown>
              {automationAction}
            </SpaceBetween>
          )}
        >
          Automation controls
        </Header>
      )}
    >
      <StartRunModal
        isOpen={isStartModalOpen}
        close={() => { setIsStartModalOpen(false); }}
        process={ProcessNames.FORMING}
      />
      <LoadConfigModal
        isOpen={isLoadModalOpen}
        close={() => { setIsLoadModalOpen(false); }}
        process={ProcessNames.FORMING}
      />
      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}>
        <TemperaturePanel
          side="upper"
          fields={FORMING_TEMP_FIELDS_BY_SIDE.upper}
        />
        <TemperaturePanel
          side="lower"
          fields={FORMING_TEMP_FIELDS_BY_SIDE.lower}
        />
        <SpaceBetween size="s">
          <ProcessStatus />
          <PLCToggleButton
            path={PLC_PATHS.cmd.standbyHeatToLoadingEnable}
            trueLabel="Disable standby heating"
            falseLabel="Enable standby heating"
          />
          <PLCToggleButton
            path={PLC_PATHS.cmd.formingRecipe.autoIonizer}
            trueLabel="Disable ionizer automation"
            falseLabel="Enable ionizer automation"
          />
          <PLCToggleButton
            path={PLC_PATHS.cmd.formingRecipe.autoVacuum}
            trueLabel="Disable vacuum automation"
            falseLabel="Enable vacuum automation"
          />
          <SpaceBetween size="xs">
            {FORMING_SOAK_TIME_FIELDS.map((field) => (
              <PLCNumberEditor
                key={field.path.name}
                field={field}
              />
            ))}
          </SpaceBetween>
        </SpaceBetween>
        <ProcessLogPanel processLogId={processLogId} />
      </Grid>
    </Container>
  );
}
